import { render, staticRenderFns } from "./LinkToPageInner.vue?vue&type=template&id=3da873c4&"
import script from "./LinkToPageInner.vue?vue&type=script&lang=js&"
export * from "./LinkToPageInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports